import { Box, Divider, Typography } from "@mui/material";
import useAPI from "../../../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../../../api/hooks/useColors";
import IconButton from "../../../../../../../../components/buttons/IconButton";
import SvgToIcon from "../../../../../../../../icons/SvgToIcon";
import { icons } from "../../../../../../../stack/environment/icons/iconExport";
import RegularCommentBlock from "./RegularCommentBlock";

export default function ResolvedComment({
  log,
  isHovered,
  isExpanded,
  setIsExpanded,
}) {
  const colors = useColors();
  const { trackEvent } = useAPI();

  const handleExpand = () => {
    const action = isExpanded ? "collapsed" : "expanded";
    trackEvent(`User ${action} the resolved comment ${log.log_id}`);
    setIsExpanded((prev) => !prev);
  };

  return (
    <>
      {isExpanded && (
        <>
          <RegularCommentBlock log={log} isHovered={isHovered} />
          <Divider sx={{ borderColor: colors.divider }} />
        </>
      )}
      <Box padding="4px">
        <Box
          display="flex"
          height="25px"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center" gap={1}>
            <SvgToIcon
              width="16px"
              IconLogo={icons.ResolveIcon}
              style={{ color: colors.icon_input_success }}
            />
            <Typography
              variant="subtitle2"
              color={colors.text_secondary}
              component="span"
              fontWeight={500}
            >
              {log.resolved_by_display_name}{" "}
              <Typography
                variant="body2"
                color={colors.text_secondary}
                component="span"
              >
                resolved the comment
              </Typography>
            </Typography>
          </Box>
          <IconButton
            onClick={handleExpand}
            IconSVG={
              isExpanded ? icons.CollapseCommentIcon : icons.ExpandCommentIcon
            }
            buttonStyle="standard"
            size="XS"
          />
        </Box>
      </Box>
    </>
  );
}
